import { module } from 'angular';

import { ContactKnowledgeBase, default as contactKnowledgeBaseName } from './knowledge-base.component.ajs';

export default module('contact.agent.helpzone.knowledge-base', []).component(contactKnowledgeBaseName, new ContactKnowledgeBase()).name;
